
import React from 'react';
import { downloads } from '../constants';
import { useSEO, seoConfigs } from '../hooks/useSEO';

export const DownloadsPage: React.FC = () => {
  useSEO(seoConfigs.downloads);
  return (
    <div className="py-8">
      <h1 className="text-4xl font-bold text-center text-sky-400 mb-12">Helpful Downloads</h1>
      <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto text-center">
        Some useful resources for your sound and music workflows.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {downloads.map((item) => (
          <div key={item.id} className="bg-zinc-900 p-6 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300 flex flex-col justify-between">
            <div>
              <h2 className="text-2xl font-semibold text-sky-300 mb-3">{item.name}</h2>
              <p className="text-gray-300 text-base mb-4">{item.description}</p>
            </div>
            <div className="flex items-center justify-between mt-4">
              <span className="text-gray-400 text-sm">{item.fileSize}</span>
              <div className="flex space-x-2">
                {(item.id === 1 || item.description === 'My personal 5.1 surround sound Pro Tools template for post production workflows, including complete stems track layouts, busses.') && (
                  <a
                    href="https://www.youtube.com/watch?v=84LgQP5D1GY"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full transition-colors duration-300"
                  >
                    <svg
                      className="w-4 h-4 mr-2"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                    </svg>
                    Watch Video
                  </a>
                )}
                <a
                  href={item.link}
                  download
                  className="inline-flex items-center bg-sky-600 hover:bg-sky-700 text-white font-bold py-2 px-4 rounded-full transition-colors duration-300"
                >
                  <svg
                    className="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    ></path>
                  </svg>
                  Download
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
